var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTdIconContactDisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9620",
    "data-name": "Rectangle 9620",
    width: 186,
    height: 186,
    transform: "translate(0 -0.036)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3369",
    "data-name": "Group 3369",
    transform: "translate(0 0.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2454",
    "data-name": "Group 2454",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M186.01,93A93,93,0,1,1,93,0a93,93,0,0,1,93,93",
    transform: "translate(0 0.061)",
    fill: "#f09337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M411.191,439.078V423.893H396v5.178h6.443L396,435.063l3.558,3.861,6.432-5.968v6.121Z",
    transform: "translate(-281.799 -301.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M454.043,423.765l.014.351.021,0h-.023V438.5h0l-.011.506.1-.073-.1.075s.179.012.488.012c1.87,0,8.51-.45,9.042-6.818a3.484,3.484,0,0,0,.035-.5c0-.09,0-.179-.01-.267.031-.542.248-7.551-9.555-7.678",
    transform: "translate(-323.103 -301.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M235.579,334.443h-103.4a4.686,4.686,0,0,1-4.681-4.681V268.181a4.686,4.686,0,0,1,4.681-4.681h103.4a4.686,4.686,0,0,1,4.681,4.681v61.582a4.686,4.686,0,0,1-4.681,4.681m-103.4-69.213a2.953,2.953,0,0,0-2.95,2.95v61.582a2.953,2.953,0,0,0,2.95,2.95h103.4a2.953,2.953,0,0,0,2.95-2.95V268.181a2.954,2.954,0,0,0-2.95-2.95Z",
    transform: "translate(-90.731 -187.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M219.977,128.228s13.022-.807,17.137-.952a3.766,3.766,0,0,0,3.933-3.933l-8.093-8.093L185.289,72.2l-47.272,42.658-8.36,8.36s.664,3.914,4.563,4.058,16.99.776,16.99.776l34.271-29.7Z",
    transform: "translate(-92.266 -51.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M188.41,295.708l-54.544-27.229.773-1.548,53.771,26.844L242.18,266.93l.773,1.548Z",
    transform: "translate(-95.261 -189.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M152.954,228.036V208h98.454v20.036l-49.415,24.481Z",
    transform: "translate(-108.844 -147.954)",
    fill: "#f09337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M199.857,251.349l-49.9-24.912V205H250.139v21.438Zm-48.172-25.983,48.175,24.05,48.549-24.052V206.731H151.684Z",
    transform: "translate(-106.709 -145.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M126.859,249.107s-2.064,2.42-.622,8.188l7.354-4.182Z",
    transform: "translate(-89.468 -177.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M500.932,249.107s2.064,2.42.622,8.188L495,253.4Z",
    transform: "translate(-352.248 -177.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M130.5,258.354l6.476,3.839L136.7,256Z",
    transform: "translate(-92.865 -182.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M494.351,259.956v4.536l2.633-.7,2.745-2.384Z",
    transform: "translate(-351.786 -184.927)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M203.721,253.442h67.194a.721.721,0,1,0,0-1.442H203.721a.721.721,0,1,0,0,1.442",
    transform: "translate(-144.457 -179.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M203.721,284.442h67.194a.721.721,0,1,0,0-1.442H203.721a.721.721,0,1,0,0,1.442",
    transform: "translate(-144.457 -201.325)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdIconContactDisk);
export default __webpack_public_path__ + "static/media/TD_Icon_Contact_Disk.2942f7001368d93f58a421f16395383a.svg";
export { ForwardRef as ReactComponent };